
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rank",
      function () {
        return require("private-next-pages/rank/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rank"])
      });
    }
  